import { useContext } from "react";
import { AuthContext } from "../providers/AuthProvider";

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    // Prevent crash: show alert or log
    if (typeof window !== 'undefined' && window.alert) {
      window.alert("Auth system not available. Please refresh the page.");
    } else {
      console.warn("useAuth hook must be used with AuthProvider");
    }
    // Return fallback values
    return {
      authAttempted: false,
      user: null,
    };
  }
  const { authAttempted, user } = context;
  return { authAttempted, user };
};
